import { supabase } from '../lib/supabase';

/**
 * Service for sending registration status SMS via Supabase Edge Function
 */
export const smsService = {
  /**
   * Send registration status SMS
   * @param {string} mobile_number - 10-digit mobile number
   * @param {string} registration_number - Registration number (e.g., 'MI-2024-000001' or '786')
   * @param {string} status - Registration status ('submitted', 'approved', 'rejected', etc.)
   * @returns {Promise<{success: boolean, message?: string, error?: string}>}
   */
  async sendRegistrationStatusSMS(mobile_number, registration_number, status) {
    try {
      const { data, error } = await supabase.functions.invoke('send-registration-status-sms', {
        body: {
          mobile_number: mobile_number,
          registration_number: registration_number,
          status: status
        }
      });

      if (error) {
        console.error('Error calling send-registration-status-sms function:', error);
        return {
          success: false,
          error: error.message || 'Failed to send SMS. Please try again.'
        };
      }

      if (!data || !data.success) {
        return {
          success: false,
          error: data?.error || 'Failed to send SMS. Please try again.'
        };
      }

      return {
        success: true,
        message: data.message || 'SMS sent successfully'
      };
    } catch (error) {
      console.error('Error in sendRegistrationStatusSMS:', error);
      return {
        success: false,
        error: error.message || 'Failed to send SMS. Please try again.'
      };
    }
  }
};

